module.exports = __webpack_public_path__ + "static/img/4295_phase_function_Paper_PointsHejduk_Prediction.fa52305.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4295_phase_function_Paper_PointsHejduk_Prediction.png
// module id = M5gi
// module chunks = 0